import React, { useMemo } from 'react';

type Segment = { text: string; state: 'ok' | 'error' | 'missed' };

/** Group characters into runs so a long passage renders as a handful of spans */
const diff = (typed: string, original: string): Segment[] => {
  const segments: Segment[] = [];
  const push = (char: string, state: Segment['state']) => {
    const last = segments[segments.length - 1];
    if (last && last.state === state) last.text += char;
    else segments.push({ text: char, state });
  };
  for (let i = 0; i < typed.length; i++) push(typed[i], typed[i] === original[i] ? 'ok' : 'error');
  // Show where the test stopped with a short tail of the untyped text
  const tail = original.slice(typed.length, typed.length + 60);
  if (tail) push(`${tail}…`, 'missed');
  return segments;
};

// The passage as typed, mistakes highlighted (same presentation as the admin Details panel)
export function TypedPassage({ typed, original }: { typed: string; original: string }) {
  const segments = useMemo(() => diff(typed || '', original || ''), [typed, original]);
  return (
    <p className="typed-passage">
      {segments.map((s, i) =>
        s.state === 'ok' ? (
          <span key={i}>{s.text}</span>
        ) : s.state === 'error' ? (
          <mark key={i}>{s.text}</mark>
        ) : (
          <span key={i} className="missed">
            {s.text}
          </span>
        )
      )}
    </p>
  );
}
